import { render, staticRenderFns } from "./presenze.vue?vue&type=template&id=4e840772&"
import script from "./presenze.vue?vue&type=script&lang=js&"
export * from "./presenze.vue?vue&type=script&lang=js&"
import style0 from "./presenze.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports